import './index.scss';
import Sidebar from '../Sidebar';
import {Outlet} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faPhone} from '@fortawesome/free-solid-svg-icons';

const Layout = () =>{
    return (
        <div className = 'App'> 
            <Sidebar/>
            <div className = 'page'>
                <div className= 'container-contact'>
                    <div className = 'email'>
                        <a href = "mailto: rohansl@vt.edu">
                            <FontAwesomeIcon icon={faEnvelope} color='#4d4d4e'/>  
                            rohansl@vt.edu
                        </a>
                    </div>

                    <div className = 'phone'>
                        <a href= 'tel: +1-540-824-8637'>
                            <FontAwesomeIcon icon={faPhone} color='#4d4d4e'/>      
                            +1-540-824-8637
                        </a>
                    </div> 
                </div>
            </div>

            <Outlet/>

        </div>
    )
}

export default Layout;